export const getMessageDelayTime = () => {
  const expiryTimeMsStr = localStorage.getItem("expiryTimeMs");
  const expiryTimeMs = Number(expiryTimeMsStr);
  const FIVE_MINUTES_MS = 5 * 60 * 1000;
  const alertTime = expiryTimeMs - FIVE_MINUTES_MS;
  const delay = alertTime - Date.now();
  return delay;
};


export const removeLocalStorage = () => {
  const expiryTimeMsStr = localStorage.getItem("expiryTimeMs");
  const removeLSdelay = Number(expiryTimeMsStr);

  const alertTime = removeLSdelay - Date.now()
  return alertTime
};
